import React from 'react';
import { Link } from "react-router-dom";

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import ExtensionIcon from '@material-ui/icons/Extension';
import InfoIcon from '@material-ui/icons/Info';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';

import QCRIlogo from './img/qcri-logo.png';
import NatiQlogo from './img/NatiQ.png';

class Header extends React.Component {
  state = {
    menuAnchorEl: null
  }

  handleMenu = event => {
    this.setState({ menuAnchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ menuAnchorEl: null });
  };

  render() {
    return (
      <AppBar position="static">
        <Toolbar>
          <Hidden smDown>
            <Link to="/" style={{display: "flex", alignItems: "center"}}>
              <img src={QCRIlogo} className="App-logo" alt="logo" />
              <img src={NatiQlogo} style={{maxHeight: '60px'}} className="App-logo" alt="logo" />
            </Link>
            <Typography variant="h3" color="inherit" align="center" className="App-title">
              NatiQ: Arabic Text to Speech
            </Typography>
            <Button component={Link} to="/reference/" variant="outlined" size="small" color="secondary" style={{margin: '5px'}}>
              <ExtensionIcon style={{margin: '5px'}}/>
              API Reference
            </Button>
            <Button component={Link} to="/about/" variant="outlined" size="small" color="secondary" style={{margin: '5px'}}>
              <InfoIcon style={{margin: '5px'}}/>
              About
            </Button>
          </Hidden>
          <Hidden mdUp>
            <Typography variant="h5" color="inherit" align="center" className="App-title">
              NatiQ: Arabic Text to Speech
            </Typography>
            <div>
              <IconButton
                aria-owns={Boolean(this.state.menuAnchorEl) ? 'menu-appbar' : undefined}
                aria-haspopup="true"
                onClick={this.handleMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={this.state.menuAnchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(this.state.menuAnchorEl)}
                onClose={this.handleMenuClose}
              >
                <MenuItem onClick={this.handleMenuClose}>API Reference</MenuItem>
                <MenuItem onClick={this.handleMenuClose}>About</MenuItem>
              </Menu>
            </div>
          </Hidden>
        </Toolbar>
      </AppBar>
    )
  }
}

export default Header;
